import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const zipCodesReducer = foxGridReducer(gridNames.zipCodesManagement);

export default zipCodesReducer;
